import { isMap, parseAllDocuments } from "yaml";

import type { SettingsOverrides } from "./helpers";

/** Why a settings override file would fail to load, or null if it is fine. */
export function validateSettingsOverrideYaml(value: string): string | null {
  for (const doc of parseAllDocuments(value)) {
    const [error] = doc.errors;
    if (error) {
      // The first line carries the reason and position, the rest is a snippet.
      return error.message.split("\n")[0].replace(/:$/, "");
    }

    if (doc.contents != null && !isMap(doc.contents)) {
      return "Expected a mapping of `setting: value` pairs";
    }
  }

  return null;
}

/** Validation errors keyed by file name, for files that have one. */
export function validateSettingsOverrides(
  overrides: SettingsOverrides,
): Map<string, string> {
  const errors = new Map<string, string>();
  for (const [fileName, value] of Object.entries(overrides)) {
    const error = validateSettingsOverrideYaml(value);
    if (error) {
      errors.set(fileName, error);
    }
  }
  return errors;
}
